export const buttonBlockType = {
  DEFAULT: 'DEFAULT',
  LINK: 'LINK',
  SHOW_ALLERGENS: 'SHOW_ALLERGENS',
  HIDE_ALLERGENS: 'HIDE_ALLERGENS'
};
